<template>
  <div class="md-layout">
    <div
      class="md-layout-item md-size-100 md-small-size-100 md-medium-size-100"
    >
      <md-card>
        <md-card-content>
          <div class="md-layout">
            <div
              class="
                md-layout-item md-size-100 md-small-size-100 md-medium-size-100
              "
              style="text-align: center"
            >
              <button class="votebtn" @click="onRowClick('purpose')">
                <a>
                  <div style="text-align: center">
                    <p><i class="fas fa-briefcase"></i>Purpose</p>
                  </div>

                  <div style="text-align: center"></div>
                </a></button
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <button class="votebtn" @click="onRowClick('expense')">
                <a>
                  <!-- <div style="text-align:center;"></div> -->

                  <div style="text-align: center">
                    <p><i class="fas fa-money-bill-alt"></i> Expense</p>
                  </div>
                </a></button
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <button class="votebtn" @click="onRowClick('territory')">
                <a>
                  <!-- <div style="text-align:center;"><i class="fas fa-street-view"></i></div> -->
                  <div style="text-align: center">
                    <p><i class="fas fa-street-view"></i>Territory</p>
                  </div>
                </a></button
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <button class="votebtn" @click="onRowClick('industry')">
                <a>
                  <!-- <div style="text-align:center;"><i class="fas fa-industry"></i></div> -->
                  <div style="text-align: center">
                    <p><i class="fas fa-industry"></i>Industry</p>
                  </div>
                </a></button
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <button class="votebtn" @click="onRowClick('list')">
                <a>
                  <!-- <div style="text-align:center;"><i class="fas fa-list"></i></div> -->
                  <div style="text-align: center">
                    <p><i class="fas fa-list"></i>List</p>
                  </div>
                </a></button
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <button class="votebtn" @click="onRowClick('office')">
                <a>
                  <!-- <div style="text-align:center;"><i class="fas fa-map-marked-alt"></i></div> -->
                  <div style="text-align: center">
                    <p><i class="fas fa-map-marked-alt"></i>Office</p>
                  </div>
                </a>
              </button>
            </div>
          </div>
        </md-card-content>
      </md-card>

      <md-card>
        <md-card-content>
          <div class="md-layout">
            <div
              v-if="noticepurpose"
              class="
                md-layout-item md-size-100 md-small-size-100 md-medium-size-100
              "
              style="float: right"
            >
              <purpose
                @on-close="closeModel('noticepurpose')"
                :userid="userId"
              />
            </div>
            <div
              v-else-if="noticeexpense"
              class="
                md-layout-item md-size-100 md-small-size-100 md-medium-size-100
              "
              style="float: right"
            >
              <expense
                @on-close="closeModel('noticeexpense')"
                :userid="userId"
              />
            </div>
            <div
              v-else-if="noticeterritory"
              class="
                md-layout-item md-size-100 md-small-size-100 md-medium-size-100
              "
              style="float: right"
            >
              <territory
                @on-close="closeModel('noticeterritory')"
                :userid="userId"
              />
            </div>
            <div
              v-else-if="noticeindustry"
              class="
                md-layout-item md-size-100 md-small-size-100 md-medium-size-100
              "
              style="float: right"
            >
              <industry
                @on-close="closeModel('noticeindustry')"
                :userid="userId"
              />
            </div>
            <div
              v-else-if="noticelist"
              class="
                md-layout-item md-size-100 md-small-size-100 md-medium-size-100
              "
              style="float: right"
            >
              <list @on-close="closeModel('noticelist')" :userid="userId" />
            </div>
            <div
              v-else-if="noticeoffice"
              class="
                md-layout-item md-size-100 md-small-size-100 md-medium-size-100
              "
              style="float: right"
            >
              <office @on-close="closeModel('noticeoffice')" :userid="userId" />
            </div>
            <div
              v-else
              class="
                md-layout-item md-size-100 md-small-size-100 md-medium-size-100
              "
              style="text-align: center"
            >
              <h4>Please select menu from the top.</h4>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>
import { APIService } from "../../../../apiservice.js";
import purpose from "./purpose.vue";
import expense from "./expense.vue";
import territory from "./territory.vue";
import industry from "./industry.vue";
import list from "./list.vue";
import office from "./office.vue";
export default {
  components: {
    purpose,
    expense,
    territory,
    industry,
    list,
    office,
  },
  data() {
    return {
      noticepurpose: false,
      noticeexpense: false,
      noticeterritory: false,
      noticeindustry: false,
      noticelist: false,
      noticeoffice: false,
      tableData: [
        {
          dropdown: "Purpose",
          description: "",
          default: "purpose",
        },
        {
          dropdown: "Expense Categories",
          description: "",
          default: "expense",
        },
        {
          dropdown: "Territory Categories",
          description: "",
          default: "territory",
        },
        {
          dropdown: "Industry Categories",
          description: "",
          default: "industry",
        },
        {
          dropdown: "List Categories",
          description: "",
          default: "list",
        },
        {
          dropdown: "Office Location",
          description: "",
          default: "office",
        },
      ],
      userId: "",
    };
  },
  methods: {
    closeModel(value) {
      let self = this;
      self[value] = false;
    },
    closeModelfunding(value) {
      let self = this;
      self[value] = false;
    },
    onRowClick(path) {
      var self = this;
      if (path == "purpose") {
        if (this.noticepurpose == true) {
          this.noticepurpose = true;
          this.noticeexpense = false;
          this.noticeterritory = false;
          this.noticeindustry = false;
          this.noticelist = false;
          this.noticeoffice = false;
        } else {
          var app = this;

          this.noticepurpose = true;
          this.noticeexpense = false;
          this.noticeterritory = false;
          this.noticeindustry = false;
          this.noticelist = false;
          this.noticeoffice = false;
        }
      }
      if (path == "expense") {
        var app = this;
        this.noticepurpose = false;
        this.noticeexpense = true;
        this.noticeterritory = false;
        this.noticeindustry = false;
        this.noticelist = false;
        this.noticeoffice = false;
      }
      if (path == "territory") {
        var app = this;
        this.noticepurpose = false;
        this.noticeexpense = false;
        this.noticeterritory = true;
        this.noticeindustry = false;
        this.noticelist = false;
        this.noticeoffice = false;
      }

      if (path == "industry") {
        var app = this;
        this.noticepurpose = false;
        this.noticeexpense = false;
        this.noticeterritory = false;
        this.noticeindustry = true;
        this.noticelist = false;
        this.noticeoffice = false;
      }
      if (path == "list") {
        var app = this;
        this.noticepurpose = false;
        this.noticeexpense = false;
        this.noticeterritory = false;
        this.noticeindustry = false;
        this.noticelist = true;
        this.noticeoffice = false;
      }
      if (path == "office") {
        this.noticepurpose = false;
        this.noticeexpense = false;
        this.noticeterritory = false;
        this.noticeindustry = false;
        this.noticelist = false;
        this.noticeoffice = true;
      }
    },
    getUserinfo() {
      APIService.getUserInfo().then((res) => {
        if (res.status == 200) {
          this.userId = res.data._id;
        }
      });
    },
  },
  created() {
    this.getUserinfo();
  },
};
</script>
<style scoped>
.votebtn {
  /* padding: 10px 10px; */
  background: #425276;
  font-size: 18px;
  cursor: pointer;
  text-align: left;
  width: 170px;
  /* height: 55px; */
}
.votebtn a i {
  padding-right: 10px;
  font-size: 20px;
}
a {
  color: white !important;
}
p {
  margin-top: -2 !important;
  margin-bottom: 1rem;
}
</style>